import Accessories             from 'scripts/defa/control/accessories-holder/accessories/collection-accessories';
import AddNewAccessory         from 'scripts/defa/control/accessories-holder/view-add-new-accessory-view';
import AccessoryCollectionView from 'scripts/defa/control/accessories-holder/accessories/view-accessory-collection-view';
import AccessoryDetailsView    from 'scripts/defa/control/accessories-holder/accessories/view-accessory-details-view';
import ControlModule           from 'scripts/poppet/control-module';
import { Vue }                 from 'vue/defavue';
import template                from './controlAccessoryView.jst.html';

const selectors = {
	zone1              : '[data-region=zone1]',
	zone2              : '[data-region=zone2]',
	zone3              : '[data-region=zone3]',
	zone4              : '[data-region=zone4]',
	zone5              : '[data-region=zone5]',
	zone6              : '[data-region=zone6]',
	other              : '[data-region=other]',
	unconfigured       : '[data-region=unconfigured]',
	regionGroupByZone  : '[data-region=groupByZone-container]',
	regionAccessory    : '[data-region=accessories-container]',
	regionZone1        : '[data-region=accessories-zone1]',
	regionZone2        : '[data-region=accessories-zone2]',
	regionZone3        : '[data-region=accessories-zone3]',
	regionZone4        : '[data-region=accessories-zone4]',
	regionZone5        : '[data-region=accessories-zone5]',
	regionZone6        : '[data-region=accessories-zone6]',
	regionOther        : '[data-region=accessories-other]',
	regionUnconfigured : '[data-region=accessories-unconfigured]',
	regionAddNew       : '[data-region=new-accessory-container]',
	toggleButton       : '[data-toggle=expand-spoiler]',
	addNewButton       : '[data-click=add-new-accessory]',
	refreshButton      : '[data-click=accessory-refresh]',
};

export const ControlAccessoriesView = ControlModule.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	template : template,
	expandedNavState  : 'unit:control:accessories',
	compressedNavState: 'unit:control:overview',
	
	ui: {
		toggle: selectors.toggleButton,
		refresh: selectors.refreshButton,
		addNew: selectors.addNewButton,
	},
	
	regions: {
		container   : selectors.regionAccessory,
		zone1       : selectors.regionZone1,
		zone2       : selectors.regionZone2,
		zone3       : selectors.regionZone3,
		zone4       : selectors.regionZone4,
		zone5       : selectors.regionZone5,
		zone6       : selectors.regionZone6,
		other       : selectors.regionOther,
		unconfigured: selectors.regionUnconfigured,
	},
	
	events: {
		'click @ui.toggle'  : 'onClickToggle', // super
		'click @ui.addNew'  : 'onClickAddNewAccessory',
		'click @ui.refresh' : 'onClickRefresh',
	},
	
	className: function () {
		return this._getClassName( 'control-accessories' );
	},
	
	templateContext: function() {
		let superContext = ControlModule.prototype.templateContext.call( this );
		return _.extend( superContext, {
			zone1Alias: this.options.settingsHome.get('zone1').zoneAlias || '',
			zone2Alias: this.options.settingsHome.get('zone2').zoneAlias || '',
			zone3Alias: this.options.settingsHome.get('zone3').zoneAlias || '',
			zone4Alias: this.options.settingsHome.get('zone4').zoneAlias || '',
			zone5Alias: this.options.settingsHome.get('zone5').zoneAlias || '',
			zone6Alias: this.options.settingsHome.get('zone6').zoneAlias || ''
		})
	},
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	onDomRefresh() {
		let self   = this;
		
		new Vue( {
			el: '#accessories-error',
			bb() {
				return {
					model: self.model,
				};
			}
		});
	},
	
	
	onClickToggle( event ) {
		ControlModule.prototype.onClickToggle.call( this, event );
		this._showAccessoryList();
	},
	
	onClickAddNewAccessory( event ) {
		this._showAddNewAccessoryView();
	},
	
	onClickRefresh (event) {
		this.model.refresh();
	},
	
	onChildviewShowAccessory: function(id) {
		this._showSingleView();
		
		let detailsView = new AccessoryDetailsView( {
			model: this._allAccessories().get(id),
		} );
		this.showChildView( 'container', detailsView );
	},
	
	onChildviewAccessoryClose: function( accessory) {
		if(accessory.hasChanged()){
			this.model.refresh();
		}
		this._showAccessoryList();
	},
	
	onChildviewSaveConfig: function( accessory, options ) {
		this.model.saveDimplex( accessory, options );
	},
	
	onChildviewSaveZone: function ( accessory, options ) {
		this.model.saveZone( accessory, options );
	},
	
	onChildviewRemoveAccessory: function ( accessory, options ) {
		this.model.removeAccessory( accessory, options );
	},
	
	onChildviewAddAccessory: function( serial, options ){
		this.model.addAccessory( serial, options );
		
	},
	
	onRender: function() {
		this._showAccessoryList();
	},
	
	afterModelComplete() {
		this._showAccessoryList();
	},
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------

	_showAccessoryList: function() {
		this._showListAndAddNewView();
		this._showCollectionRegion('zone1', selectors.zone1, 1);
		this._showCollectionRegion('zone2', selectors.zone2, 2);
		this._showCollectionRegion('zone3', selectors.zone3, 3);
		this._showCollectionRegion('zone4', selectors.zone4, 4);
		this._showCollectionRegion('zone5', selectors.zone5, 5);
		this._showCollectionRegion('zone6', selectors.zone6, 6);
		this._showCollectionRegion('other', selectors.other, 0);
		this._showCollectionRegion('unconfigured', selectors.unconfigured, 15);
	},
	
	_allAccessories: function() {
		return this.model.get('allAccessories');
	},
	
	_showAddNewAccessoryView: function () {
		this._showSingleView();
		let addNewAccessory = new AddNewAccessory( _.extend( this.options, {
			model: this.options.unit,
		} ) );
		this.showChildView( 'container', addNewAccessory);
	},
	
	_showListAndAddNewView: function() {
		this.$el.find( selectors.regionAddNew ).removeAttr( 'hidden' );
		this.$el.find( selectors.regionGroupByZone ).removeAttr( 'hidden' );
		this.$el.find( selectors.regionAccessory ).prop( 'hidden', true );
	},
	
	_showSingleView: function() {
		this.$el.find( selectors.regionAddNew ).prop( 'hidden', true );
		this.$el.find( selectors.regionGroupByZone ).prop( 'hidden', true );
		this.$el.find( selectors.regionAccessory ).removeAttr( 'hidden' );
	},
	
	_showCollectionRegion(regionName, area, zoneNumber) {
		let accessories = this.model.getZoneAccessories(zoneNumber)
		let collectionView = new AccessoryCollectionView( {
			collection: new Accessories(accessories),
		} );
		this.showChildView( regionName, collectionView );
		
		if ( collectionView.isEmpty() ) {
			this.$el.find( area ).prop( 'hidden', true );
		} else {
			this.$el.find( area ).removeAttr( 'hidden' );
		}
	}

});

export default ControlAccessoriesView;
